import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import SplashSelector from './SplashSelector';
import ClueSortGame from './clue-sort/ClueSortGame';
import App from '../App';  // Import the original game App
import './GameContainer.css';

const GameContainer = () => {
  const navigate = useNavigate();
  const [currentGame, setCurrentGame] = useState(null);
  const [showHomeButton, setShowHomeButton] = useState(true);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowHomeButton(scrollPosition <= 100);
    };
    
    // Set initial value
    handleScroll();
    
    // Add event listener
    window.addEventListener('scroll', handleScroll);
    
    // Clean up
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const handleSelectGame = (gameType) => {
    setCurrentGame(gameType);
    if (gameType === 'mystery') {
      navigate('/mystery');
    } else if (gameType === 'clue-sort') {
      navigate('/clue-sort');
    }
  };
  
  const handleReturnHome = () => {
    setCurrentGame(null);
    navigate('/');
  };
  
  return (
    <div className="game-container">
      <Routes>
        <Route path="/" element={currentGame ? <Navigate to={`/${currentGame}`} /> : <SplashSelector onSelectGame={handleSelectGame} />} />
        <Route 
          path="/mystery" 
          element={
            <div className="game-wrapper">
              <div className={`home-button ${showHomeButton ? 'visible' : 'hidden'}`} onClick={handleReturnHome}>
                <img src={`${process.env.PUBLIC_URL}/images/hamburger.png`} alt="Home" />
              </div>
              <App skipSplash={true} />
            </div>
          } 
        />
        <Route 
          path="/clue-sort" 
          element={
            <div className="game-wrapper">
              <div className={`home-button ${showHomeButton ? 'visible' : 'hidden'}`} onClick={handleReturnHome}>
                <img src={`${process.env.PUBLIC_URL}/images/hamburger.png`} alt="Home" />
              </div>
              <ClueSortGame />
            </div>
          } 
        />
      </Routes>
    </div>
  );
};

export default GameContainer; 